import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AccOfferedSeatCountsPart } from '../../../acc-offered-seat-counts/acc-offered-seat-counts.part';


@Component({
	selector: 'admissions-manager-tab-2-part',
	standalone: true,
	imports: [AccOfferedSeatCountsPart],
	templateUrl: './admissions-manager-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./admissions-manager-tab-2.part.scss`],
})
export class AdmissionsManagerTab2Part {
}
